import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HttpParamsService {
  /**
   * appendParams
   * Append params from requests
   *
   * @param request Record<PropertyKey, unknown>
   * @returns HttpParams
   */
  toParams(request: Record<PropertyKey, unknown>): HttpParams {
    let params = new HttpParams();
    Object.keys(request).forEach((key) => {
      if (key in request && request[key] !== null && request[key] !== undefined) {
        params = this._addParams(request[key] as string | Array<string>, params, key);
      }
    });
    return params;
  }

  /**
   * _addParams
   * Append new params to params
   *
   * @param value  string | Array<string>
   * @param params HttpParams
   * @param filter string
   * @returns HttpParams
   */
  private _addParams(value: string | Array<string>, params: HttpParams, filter: string): HttpParams {
    if (Array.isArray(value)) {
      value.forEach((code: string) => {
        params = params.append(filter, code);
      });
    } else {
      params = params.append(filter, value);
    }
    return params;
  }
}
